import React, { useRef, useImperativeHandle, forwardRef } from "react";
import SignatureCanvas from "react-signature-canvas";

const SignatureCapture = (props, ref) => {
    let refSig = useRef();
    useImperativeHandle(ref, () => ({
        saveImage: () => {
            if (refSig.current) {
                if (props.onSaveEvent) {
                    props.onSaveEvent({ encoded: refSig.current.toDataURL().split(",")[1] });
                }
            }
        },
        resetImage: () => {
            if (refSig.current) {
                refSig.current.clear();
            }
        },
        getSignature: () => {
            if (refSig.current) {
                refSig.current.clear();
            }
        },
    }));

    const onBegin = e => {
        if (props.onDragEvent) {
            props.onDragEvent(e);
        }
    };
    return <SignatureCanvas ref={refSig} canvasProps={{ ...props.style, maxWidth: props.maxSize }} penColor={props.strokeColor} onBegin={onBegin} backgroundColor={props.backgroundColor} />;
};

export default forwardRef(SignatureCapture);
